module.exports = __webpack_public_path__ + "static/media/PA-Icon-Kirche-neg.eeaae220.svg";